
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/doc/privacy",
      function () {
        return require("private-next-pages/doc/privacy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/doc/privacy"])
      });
    }
  